<template>
    <div class="pop_overay">
        <div class="pop_cont">
            <div class="full_image">
              <img :src="imgUrl()" alt="test_image">
            </div>
            <button :class="status ? 'type1' : ''" @click="closeBtn">닫기</button>
            <button v-if="status" class="type2" @click="imageLink">{{ status ? '참여하기' : '자세히 보기' }}</button>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import * as appEvent from '@/assets/js/app_event.js'
export default {
  name: 'CustomPopup',
  props: {
    status: String
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['popupGift'])
  },
  methods: {
    closeBtn () {
      this.$store.state.customPopup = false
      if (this.status) {
        this.$store.dispatch('raffleRequest', this.popupGift)
      }
      this.$store.dispatch('openPopupGift', {})
    },
    imageLink () {
      let url = ''
      if (this.status) {
        url = 'https://form.office.naver.com/form/responseView.cmd?formkey=MjQxYzNlOWMtOTYyOC00MTQ0LWFlNzQtODU5MDIyZmNmYjlm&sourceId=urlshare'
      } else {
        url = 'https://www.instagram.com/p/CnVjE7Iy7iB/?igshid=YmMyMTA2M2Y%3D'
      }
      appEvent.urlLink(url)
    },
    imgUrl () {
      return require(`@/assets/images/${this.status ? 'hc_sub_new.png' : 'hc_main_new.png'}`)
    }
  },
  mounted () {
  },
  destroyed () {
  }
}
</script>
<style>
  .full_image {
    background-color: #fff;
    line-height: 0;
  }
  .full_image img {
    width: 100%;
  }
  .pop_overay .pop_cont button {
    border-left: 0!important;
  }
</style>
